import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { inject, InjectionToken } from '@angular/core';

import { APP_CONFIG } from '@services/app-config.token';

import { environment } from '../../../environments/environment';

export const APP_INSIGHTS_INSTANCE_TOKEN = new InjectionToken('APP_INSIGHTS_INSTANCE_TOKEN', {
  providedIn: 'root',
  factory: (): ApplicationInsights | null => {
    const appConfig = inject(APP_CONFIG);

    return environment.production
      ? new ApplicationInsights({
          config: {
            instrumentationKey: appConfig.AppInsights.InstrumentationKey,
            enableAutoRouteTracking: true,
          },
        })
      : null;
  },
});
